module.exports = __webpack_public_path__ + "static/media/icon-edit.2b8e58fa.svg";